import { useState, useCallback } from 'react';
import { supabase } from '@services/api';
import { buildScoreBody } from './scoreRequest';

const API_BASE = import.meta.env.VITE_APP_API_URL || 'http://localhost:3000/api';

export const useCopyScoring = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Pages pass the exercise id plus the student's input (mode, userChoice, variants,
  // defendedVariant where the mode has them). See scoreRequest.js for what is sent.
  const scoreExercise = useCallback(async (payload) => {
    setLoading(true);
    setError(null);

    try {
      const { data: { session } } = await supabase.auth.getSession();
      const token = session?.access_token;

      const res = await fetch(`${API_BASE}/copywriting/score`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
        },
        body: JSON.stringify(buildScoreBody(payload)),
      });

      if (!res.ok) {
        const errData = await res.json().catch(() => ({}));
        throw new Error(errData.error || `Scoring failed (${res.status})`);
      }

      const data = await res.json();
      return data;
    } catch (err) {
      setError(err.message || 'Scoring failed. Please try again.');
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  const clearError = useCallback(() => setError(null), []);

  const getFeatured = useCallback(async () => {
    try {
      const res = await fetch(`${API_BASE}/copywriting/featured`);
      if (!res.ok) throw new Error('Failed to fetch featured');
      return await res.json();
    } catch (err) {
      return { featured: [] };
    }
  }, []);

  return { scoreExercise, getFeatured, loading, error, clearError };
};
